<template>
<div>
  <ul class="bt">
    <li style="display: block"><p>铀曲比</p><p>临界值</p></li>
    <li>2.92</li>
    <li>2.99</li>
    <li>3.03</li>
    <li>3.07</li>
    <li>3.08</li>
    <li></li>
    <li style="display: block"><p>铀曲比</p><p>临界值</p></li>
    <li>2.92</li>
    <li>2.99</li>
    <li>3.03</li>
    <li>3.07</li>
    <li>3.08</li>
  </ul>
  <ul class="nr" style="background: rgba(197,87,19, 1);color: #FFFFFF;">
    <li style="background: rgba(197,87,19, 1);color: #FFFFFF;">年龄</li>
    <li>3-5岁</li>
    <li>6-9岁</li>
    <li>10-12岁</li>
    <li>13-15岁</li>
    <li>16-18岁</li>
    <li style="background: rgba(197,87,19, 1);color: #FFFFFF;"></li>
    <li style="background: rgba(197,87,19, 1);color: #FFFFFF;">年龄</li>
    <li>3-5岁</li>
    <li>6-9岁</li>
    <li>10-12岁</li>
    <li>13-15岁</li>
    <li>16-18岁</li>
  </ul>

  <ul class="ql">
    <li>角膜曲率</li>
    <li>不同年龄段的眼轴临界值</li>
    <li></li>
    <li>角膜曲率</li>
    <li>不同年龄段的眼轴临界值</li>
  </ul>
  <ul class="nr">
    <li>39</li>
    <li>25.27</li>
    <li>25.88</li>
    <li>26.22</li>
    <li>26.57</li>
    <li>26.65</li>
    <li></li>
    <li>43.0</li>
    <li>22.92</li>
    <li>23.47</li>
    <li>23.78</li>
    <li>24.1</li>
    <li>24.17</li>
  </ul>
  <ul class="nr">
    <li>39.1</li>
    <li>25.2</li>
    <li>25.81</li>
    <li>26.15</li>
    <li>26.5</li>
    <li>26.59</li>
    <li></li>
    <li>43.1</li>
    <li>22.87</li>
    <li>23.41</li>
    <li>23.73</li>
    <li>24.04</li>
    <li>24.12</li>
  </ul>
  <ul class="nr">
    <li>39.2</li>
    <li>25.14</li>
    <li>25.74</li>
    <li>26.09</li>
    <li>26.43</li>
    <li>26.52</li>
    <li></li>
    <li>43.2</li>
    <li>22.81</li>
    <li>23.36</li>
    <li>23.67</li>
    <li>23.98</li>
    <li>24.06</li>
  </ul>
  <ul class="nr">
    <li>39.3</li>
    <li>25.08</li>
    <li>25.68</li>
    <li>26.02</li>
    <li>26.36</li>
    <li>26.45</li>
    <li></li>
    <li>43.3</li>
    <li>22.76</li>
    <li>23.31</li>
    <li>23.62</li>
    <li>23.93</li>
    <li>24.01</li>
  </ul>
  <ul class="nr">
    <li>39.4</li>
    <li>25.01</li>
    <li>25.61</li>
    <li>25.95</li>
    <li>26.3</li>
    <li>26.38</li>
    <li></li>
    <li>43.4</li>
    <li>22.71</li>
    <li>23.25</li>
    <li>23.56</li>
    <li>23.87</li>
    <li>23.95</li>
  </ul>
  <ul class="nr">
    <li>39.5</li>
    <li>24.95</li>
    <li>25.55</li>
    <li>25.89</li>
    <li>26.23</li>
    <li>26.32</li>
    <li></li>
    <li>43.5</li>
    <li>22.66</li>
    <li>23.2</li>
    <li>23.51</li>
    <li>23.82</li>
    <li>23.9</li>
  </ul>
  <ul class="nr">
    <li>39.6</li>
    <li>24.89</li>
    <li>25.48</li>
    <li>25.82</li>
    <li>26.16</li>
    <li>26.25</li>
    <li></li>
    <li>43.6</li>
    <li>22.6</li>
    <li>23.15</li>
    <li>23.45</li>
    <li>23.76</li>
    <li>23.84</li>
  </ul>
  <ul class="nr">
    <li>39.7</li>
    <li>24.82</li>
    <li>25.42</li>
    <li>25.76</li>
    <li>26.1</li>
    <li>26.18</li>
    <li></li>
    <li>43.7</li>
    <li>22.55</li>
    <li>23.09</li>
    <li>23.4</li>
    <li>23.71</li>
    <li>23.79</li>
  </ul>
  <ul class="nr">
    <li>39.8</li>
    <li>24.76</li>
    <li>25.35</li>
    <li>25.69</li>
    <li>26.03</li>
    <li>26.12</li>
    <li></li>
    <li>43.8</li>
    <li>22.5</li>
    <li>23.04</li>
    <li>23.35</li>
    <li>23.66</li>
    <li>23.73</li>
  </ul>
  <ul class="nr">
    <li>39.9</li>
    <li>24.7</li>
    <li>25.29</li>
    <li>25.63</li>
    <li>25.97</li>
    <li>26.05</li>
    <li></li>
    <li>43.9</li>
    <li>22.45</li>
    <li>22.99</li>
    <li>23.29</li>
    <li>23.6</li>
    <li>23.68</li>
  </ul>
  <ul class="nr">
    <li>40.0</li>
    <li>24.64</li>
    <li>25.23</li>
    <li>25.57</li>
    <li>25.9</li>
    <li>25.99</li>
    <li></li>
    <li>44.0</li>
    <li>22.4</li>
    <li>22.93</li>
    <li>23.24</li>
    <li>23.55</li>
    <li>23.62</li>
  </ul>
  <ul class="nr">
    <li>40.1</li>
    <li>24.58</li>
    <li>25.17</li>
    <li>25.5</li>
    <li>25.84</li>
    <li>25.92</li>
    <li></li>
    <li>44.1</li>
    <li>22.85</li>
    <li>22.88</li>
    <li>23.19</li>
    <li>23.49</li>
    <li>23.57</li>
  </ul>
  <ul class="nr">
    <li>40.2</li>
    <li>24.51</li>
    <li>25.1</li>
    <li>25.44</li>
    <li>25.77</li>
    <li>25.86</li>
    <li></li>
    <li>44.2</li>
    <li>22.3</li>
    <li>22.83</li>
    <li>23.14</li>
    <li>23.44</li>
    <li>23.52</li>
  </ul>
  <ul class="nr">
    <li>40.3</li>
    <li>24.45</li>
    <li>25.04</li>
    <li>25.38</li>
    <li>25.71</li>
    <li>25.79</li>
    <li></li>
    <li>44.3</li>
    <li>22.25</li>
    <li>22.78</li>
    <li>23.08</li>
    <li>23.39</li>
    <li>23.47</li>
  </ul>
  <ul class="nr">
    <li>40.4</li>
    <li>24.39</li>
    <li>24.98</li>
    <li>25.31</li>
    <li>25.65</li>
    <li>25.73</li>
    <li></li>
    <li>44.4</li>
    <li>22.2</li>
    <li>22.73</li>
    <li>23.03</li>
    <li>23.34</li>
    <li>23.41</li>
  </ul>
  <ul class="nr">
    <li>40.5</li>
    <li>24.33</li>
    <li>24.92</li>
    <li>25.25</li>
    <li>25.58</li>
    <li>25.67</li>
    <li></li>
    <li>44.5</li>
    <li>22.15</li>
    <li>22.68</li>
    <li>22.98</li>
    <li>23.28</li>
    <li>23.36</li>
  </ul>
  <ul class="nr">
    <li>40.6</li>
    <li>24.27</li>
    <li>24.86</li>
    <li>25.19</li>
    <li>25.52</li>
    <li>25.6</li>
    <li></li>
    <li>44.6</li>
    <li>22.1</li>
    <li>22.63</li>
    <li>22.93</li>
    <li>23.23</li>
    <li>23.31</li>
  </ul>
  <ul class="nr">
    <li>40.7</li>
    <li>24.21</li>
    <li>24.79</li>
    <li>25.13</li>
    <li>25.46</li>
    <li>25.54</li>
    <li></li>
    <li>44.7</li>
    <li>22.05</li>
    <li>22.58</li>
    <li>22.88</li>
    <li>23.18</li>
    <li>23.26</li>
  </ul>
  <ul class="nr">
    <li>40.8</li>
    <li>24.15</li>
    <li>24.73</li>
    <li>25.06</li>
    <li>25.4</li>
    <li>25.48</li>
    <li></li>
    <li>44.8</li>
    <li>22</li>
    <li>22.53</li>
    <li>22.83</li>
    <li>23.13</li>
    <li>23.2</li>
  </ul>
  <ul class="nr">
    <li>40.9</li>
    <li>24.1</li>
    <li>24.67</li>
    <li>25</li>
    <li>25.33</li>
    <li>25.42</li>
    <li></li>
    <li>44.9</li>
    <li>21.95</li>
    <li>22.47</li>
    <li>22.78</li>
    <li>23.08</li>
    <li>23.15</li>
  </ul>
  <ul class="nr">
    <li>41.0</li>
    <li>24.04</li>
    <li>24.61</li>
    <li>24.94</li>
    <li>25.27</li>
    <li>25.35</li>
    <li></li>
    <li>45.0</li>
    <li>21.9</li>
    <li>22.43</li>
    <li>22.72</li>
    <li>23.02</li>
    <li>23.1</li>
  </ul>
  <ul class="nr">
    <li>41.1</li>
    <li>23.98</li>
    <li>24.55</li>
    <li>24.88</li>
    <li>25.21</li>
    <li>25.29</li>
    <li></li>
    <li>45.1</li>
    <li>21.85</li>
    <li>22.38</li>
    <li>22.67</li>
    <li>22.97</li>
    <li>23.05</li>
  </ul>
  <ul class="nr">
    <li>41.2</li>
    <li>23.92</li>
    <li>24.49</li>
    <li>24.82</li>
    <li>25.15</li>
    <li>25.23</li>
    <li></li>
    <li>45.2</li>
    <li>21.8</li>
    <li>22.33</li>
    <li>22.62</li>
    <li>22.92</li>
    <li>23</li>
  </ul>
  <ul class="nr">
    <li>41.3</li>
    <li>23.86</li>
    <li>24.43</li>
    <li>24.76</li>
    <li>25.09</li>
    <li>25.17</li>
    <li></li>
    <li>45.3</li>
    <li>21.75</li>
    <li>22.28</li>
    <li>22.57</li>
    <li>22.87</li>
    <li>22.95</li>
  </ul>
  <ul class="nr">
    <li>41.4</li>
    <li>23.8</li>
    <li>24.38</li>
    <li>24.7</li>
    <li>25.03</li>
    <li>25.11</li>
    <li></li>
    <li>45.4</li>
    <li>21.71</li>
    <li>22.23</li>
    <li>22.52</li>
    <li>22.82</li>
    <li>22.9</li>
  </ul>
  <ul class="nr">
    <li>41.5</li>
    <li>23.75</li>
    <li>24.32</li>
    <li>24.64</li>
    <li>24.97</li>
    <li>25.05</li>
    <li></li>
    <li>45.5</li>
    <li>21.66</li>
    <li>22.18</li>
    <li>22.48</li>
    <li>22.77</li>
    <li>22.85</li>
  </ul>
  <ul class="nr">
    <li>41.6</li>
    <li>23.69</li>
    <li>24.26</li>
    <li>24.58</li>
    <li>24.91</li>
    <li>24.99</li>
    <li></li>
    <li>45.6</li>
    <li>21.61</li>
    <li>22.13</li>
    <li>22.43</li>
    <li>22.72</li>
    <li>22.8</li>
  </ul>
  <ul class="nr">
    <li>41.7</li>
    <li>23.63</li>
    <li>24.2</li>
    <li>24.52</li>
    <li>24.85</li>
    <li>24.93</li>
    <li></li>
    <li>45.7</li>
    <li>21.56</li>
    <li>22.08</li>
    <li>22.38</li>
    <li>22.67</li>
    <li>22.75</li>
  </ul>
  <ul class="nr">
    <li>41.8</li>
    <li>23.58</li>
    <li>24.14</li>
    <li>24.46</li>
    <li>24.79</li>
    <li>24.87</li>
    <li></li>
    <li>45.8</li>
    <li>21.52</li>
    <li>22.03</li>
    <li>22.33</li>
    <li>22.62</li>
    <li>22.7</li>
  </ul>
  <ul class="nr">
    <li>41.9</li>
    <li>23.52</li>
    <li>24.08</li>
    <li>24.41</li>
    <li>24.73</li>
    <li>24.81</li>
    <li></li>
    <li>45.9</li>
    <li>21.47</li>
    <li>21.99</li>
    <li>22.28</li>
    <li>22.57</li>
    <li>22.65</li>
  </ul>
  <ul class="nr">
    <li>42.0</li>
    <li>23.46</li>
    <li>24.03</li>
    <li>24.35</li>
    <li>24.67</li>
    <li>24.75</li>
    <li></li>
    <li>46.0</li>
    <li>21.42</li>
    <li>21.94</li>
    <li>22.23</li>
    <li>22.52</li>
    <li>22.6</li>
  </ul>
  <ul class="nr">
    <li>42.1</li>
    <li>23.41</li>
    <li>23.97</li>
    <li>24.29</li>
    <li>24.61</li>
    <li>24.69</li>
    <li></li>
    <li>46.1</li>
    <li>21.38</li>
    <li>21.89</li>
    <li>22.18</li>
    <li>22.48</li>
    <li>22.55</li>
  </ul>
  <ul class="nr">
    <li>42.2</li>
    <li>23.35</li>
    <li>23.91</li>
    <li>24.23</li>
    <li>24.55</li>
    <li>24.63</li>
    <li></li>
    <li>46.2</li>
    <li>21.33</li>
    <li>21.84</li>
    <li>22.13</li>
    <li>22.43</li>
    <li>22.5</li>
  </ul>
  <ul class="nr">
    <li>42.3</li>
    <li>23.3</li>
    <li>23.86</li>
    <li>24.18</li>
    <li>24.49</li>
    <li>24.57</li>
    <li></li>
    <li>46.3</li>
    <li>21.29</li>
    <li>21.8</li>
    <li>22.09</li>
    <li>22.38</li>
    <li>22.45</li>
  </ul>
  <ul class="nr">
    <li>42.4</li>
    <li>23.24</li>
    <li>23.8</li>
    <li>24.12</li>
    <li>24.44</li>
    <li>24.52</li>
    <li></li>
    <li>46.4</li>
    <li>21.24</li>
    <li>21.75</li>
    <li>22.04</li>
    <li>22.33</li>
    <li>22.4</li>
  </ul>
  <ul class="nr">
    <li>42.5</li>
    <li>23.19</li>
    <li>23. 74</li>
    <li>24.06</li>
    <li>24.38</li>
    <li>24.46</li>
    <li></li>
    <li>46.5</li>
    <li>21.19</li>
    <li>21.7</li>
    <li>21.99</li>
    <li>22.28</li>
    <li>22.35</li>
  </ul>
  <ul class="nr">
    <li>42.6</li>
    <li>23.13</li>
    <li>23.69</li>
    <li>24.01</li>
    <li>24.32</li>
    <li>24.4</li>
    <li></li>
    <li>46.6</li>
    <li>21.15</li>
    <li>21.66</li>
    <li>21.94</li>
    <li>22.23</li>
    <li>22.31</li>
  </ul>
  <ul class="nr">
    <li>42.7</li>
    <li>23.08</li>
    <li>23.63</li>
    <li>23.95</li>
    <li>24.27</li>
    <li>24.34</li>
    <li></li>
    <li>46.7</li>
    <li>21.1</li>
    <li>21.61</li>
    <li>21.9</li>
    <li>22.19</li>
    <li>22.26</li>
  </ul>
  <ul class="nr">
    <li>42.8</li>
    <li>23.03</li>
    <li>23.68</li>
    <li>23.89</li>
    <li>24.21</li>
    <li>24.29</li>
    <li></li>
    <li>46.8</li>
    <li>21.06</li>
    <li>21.56</li>
    <li>21.85</li>
    <li>22.14</li>
    <li>22.21</li>
  </ul>
  <ul class="nr">
    <li>42.9</li>
    <li>22.97</li>
    <li>23.52</li>
    <li>23.84</li>
    <li>24.15</li>
    <li>24.23</li>
    <li></li>
    <li>46.9</li>
    <li>21.01</li>
    <li>21.52</li>
    <li>21.8</li>
    <li>22.09</li>
    <li>22.16</li>
  </ul>



</div>
</template>

<script>
export default {
  name: "jmdxt"
}
</script>

<style scoped lang="scss">
.bt {
  display: flex;
  align-items: center;
  border: 1px solid #c6c6c6;
  background: #ececec;
  li {
    width: 57px;
    border-right: 1px solid #c6c6c6;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 0;
  }
  li:nth-child(1) {width: 80px;}
  li:nth-child(7) {width: 20px;background: rgba(255,241,230)}
  li:nth-child(8) {width: 80px;}
  li:nth-child(13) {border-right: none;}
}

.nr {
  display: flex;
  align-items: center;
  border: 1px solid #c6c6c6;
  li {
    width: 57px;
    border-right: 1px solid #c6c6c6;
    height: 24px;
    line-height: 24px;
    padding: 2px 0;
  }
  li:nth-child(1) {width: 80px;background: rgb(224,222,246)}
  li:nth-child(7) {width: 20px;background: rgba(255,241,230)}
  li:nth-child(8) {width: 80px;background: rgb(224,222,246)}
  li:nth-child(13) {border-right: none;}
}
.ql {
  display: flex;
  align-items: center;
  border: 1px solid #c6c6c6;
  li {
    border-right: 1px solid #c6c6c6;
    height: 24px;
    padding: 2px 0;
  }
  li:nth-child(1) {width: 80px;}
  li:nth-child(2) {width: 287px;}
  li:nth-child(3) {width: 20px;background: rgba(255,241,230)}
  li:nth-child(4) {width: 80px;}
  li:nth-child(5) {width: 287px;border-right: none;}
}
</style>
